var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLockCore = function SvgIconLockCore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.6666C17 24.1143 17.4477 23.6666 18 23.6666C18.5523 23.6666 19 24.1143 19 24.6666C19 25.2189 18.5523 25.6666 18 25.6666C17.4477 25.6666 17 25.2189 17 24.6666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.1666C17.4477 17.1666 17 17.6143 17 18.1666C17 18.7189 17.4477 19.1666 18 19.1666C18.5523 19.1666 19 18.7189 19 18.1666C19 17.6143 18.5523 17.1666 18 17.1666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 8.66663C23 8.11434 22.5523 7.66663 22 7.66663C21.4477 7.66663 21 8.11434 21 8.66663V11.6666H14C13.4477 11.6666 13 12.1143 13 12.6666V28.6666C13 29.2189 13.4477 29.6666 14 29.6666H21V32.6666C21 33.2189 21.4477 33.6666 22 33.6666C22.5523 33.6666 23 33.2189 23 32.6666V21.6666H26C26.5523 21.6666 27 21.2189 27 20.6666V15.6666C27 15.1143 26.5523 14.6666 26 14.6666H23V8.66663ZM23 16.6666V19.6666H25V16.6666H23ZM21 27.6666V13.6666H15V27.6666H21Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLockCore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-lock-core.724e8bd8.svg";
export { ForwardRef as ReactComponent };